(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tws-product-template"]) return;
  try {
    
  $(document).ready(function () {
    adjustOptions();

    //loading OOSNotification Form Data
    let modals = $('#modalRegisterOOSNotification, #modalRegisterTestFit');
    if (modals.length > 0) {
      modals.each(function (i, modal) {
        $(modal).find('[name="productUrl"]').val(location.href);
      });
    }
  });

  $('.owl-carousel').owlCarousel({
    dots: false,
    loop: true,
    margin: 0,
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 2,
      },
      1000: {
        items: 3,
      },
    },
  });

  $('select[data-option="color"]').on('change', function () {
    let currentColor = $('select[data-option="color"]').val();
  });
  $('select[data-option="category"]').on('change', function () {
    let currentColor = $('select[data-option="color"]').val();
    let currentCategory = $('select[data-option="category"]').val();
    let firstElement = null;
    $('select[data-option="product"] > option').each(function (i, e) {
      if ($(e).attr('data-color') == currentColor && $(e).attr('data-category') == currentCategory) {
        if (firstElement === null) firstElement = e;
        $(e).show();
      } else {
        $(e).hide();
      }
    });
    if (firstElement !== null) $(firstElement).prop('selected', true);
    productOptionChange();
  });

  } catch(e) { console.error(e); }
})();
})();
